import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';

const { registerReducer } = useStorymapStore();

export class SwitchToReadOnlyMode extends Action<StorymapState> {
    public static ACTION_TYPE = 'SwitchToReadOnlyMode';

    public constructor() {
        super(SwitchToReadOnlyMode.ACTION_TYPE);
    }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const reducer = (state: StorymapState, action: SwitchToReadOnlyMode): void => {
    state.canEdit = false;
};

//@ts-ignore
registerReducer(SwitchToReadOnlyMode.ACTION_TYPE, reducer);
